const swiper = new Swiper(".swiper-header", {
  autoplay: {
    delay: 5000,
  },
  speed: 400,
  // Optional parameters
  direction: "horizontal",
  loop: true,

  // If we need pagination
  pagination: {
    el: ".swiper-pagination",
  },

  // Navigation arrows
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

const swiper2 = new Swiper(".swiper-partners", {
  autoplay: {
    delay: 3000,
  },
  slidesPerView: 1,
  speed: 400,
  // Optional parameters
  direction: "horizontal",
  loop: true,

  // If we need pagination
  pagination: {
    el: ".swiper-pagination",
  },

  // Navigation arrows
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    500: {
      slidesPerView: 2,
    },
    600: {
      slidesPerView: 3,
    },
    700: {
      slidesPerView: 4,
    },
  },
});

const swiper4 = new Swiper(".swiper-news", {
  autoplay: {
    delay: 3000,
  },
  slidesPerView: 3,
  speed: 400,
  // Optional parameters
  direction: "horizontal",
  loop: true,

  // If we need pagination
  pagination: {
    el: ".swiper-pagination",
  },

  // Navigation arrows
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    1200: {
      slidesPerView: 2,
    },
  },
});
